// extracted by mini-css-extract-plugin
export default {"wrapper":"fQa2a","tags":"p9v53","tag":"dN33L","tag--skeleton":"aHjEF","is-selected":"fYIRi"};